import { ApplicationFinancingTypeEnum } from '.spec/self-care/tsTypes';

import { QueryFilter } from '@skippay/core/utils/apiUtils';

import { getPayInThreeQueryFilter } from 'utils/payInThreeUtils';

const deferredPaymentFilter = (): QueryFilter =>
	new QueryFilter().prop('type').eq(ApplicationFinancingTypeEnum.DEFERRED_PAYMENT);

export const PAY_IN_THREE_ACTIVE_FILTER = getPayInThreeQueryFilter()
	.prop('isClosed')
	.eq('false')
	.toString();

export const PAY_IN_THREE_CLOSED_FILTER = getPayInThreeQueryFilter()
	.prop('isClosed')
	.eq('true')
	.toString();

export const DEFERRED_PAYMENT_ACTIVE_FILTER = deferredPaymentFilter()
	.prop('isClosed')
	.eq('false')
	.toString();

export const DEFERRED_PAYMENT_CLOSED_FILTER = deferredPaymentFilter()
	.prop('isClosed')
	.eq('true')
	.toString();

export const INSTALLMENTS_ACTIVE_FILTER = new QueryFilter().prop('isActive').eq('true').toString();
